module.exports = import("https://cdn.jsdelivr.net/npm/xlsx@0.18.5/xlsx.mjs");;